import { CMSLink, MediaImage, RawHtml } from '$shared/components';
import { FooterLogo } from '~/shared/components/Logo/FooterLogo';
import styles from './rich-text-area.module.css';
import { SocialLink } from '~/lib/data-contract';
import { weakKey } from '~/shared/utils/jsx';

type RichTextAreaProps = {
    text?: string;
    socialLinks?: SocialLink[];
};

export const RichTextArea = ({ text, socialLinks }: RichTextAreaProps) => {
    return (
        <section className={styles.root}>
            <div className={styles.content}>
                <FooterLogo size="large" />
                {text && <RawHtml html={text} />}
                {socialLinks && (
                    <div className={styles.socialLinks}>
                        {socialLinks.map(({ link, image }) =>
                            link ? (
                                <CMSLink
                                    key={weakKey(link)}
                                    href={link?.url}
                                    rel="noopener noreferrer"
                                    target={link?.target || '_blank'}
                                    className={styles.socialLink}
                                >
                                    {image?.src && (
                                        <MediaImage
                                            src={image.src}
                                            width={24}
                                            height={24}
                                            alt={image.alt || ''}
                                        />
                                    )}
                                </CMSLink>
                            ) : null
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};
